import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { initialize } from 'state/app';
import { useDispatch, useSelector } from 'react-redux';
import RenderWrapper from './protected-render-wrapper';

const ProtectedRoute = ({ component, path, product }) => {
  const { isInitialized, isInitInProgress, initializedProduct, user } = useSelector(
    (state) => state.app
  );
  const dispatch = useDispatch();

  const createRenderWrapper = (renderProps) => (
    <RenderWrapper
      user={user}
      initialize={(redirectOnUnauthorized, product) =>
        dispatch(initialize(redirectOnUnauthorized, product))
      }
      isInitialized={isInitialized}
      isInitInProgress={isInitInProgress}
      component={component}
      renderProps={renderProps}
      product={product}
      initializedProduct={initializedProduct}
    />
  );

  return <Route path={path} render={createRenderWrapper} />;
};

ProtectedRoute.propTypes = {
  component: PropTypes.any,
  path: PropTypes.string,
  product: PropTypes.oneOf([
    'ambassador',
    'nomad_health',
    'remote_health',
    'nomad_insurance',
    'global'
  ])
};

export default ProtectedRoute;
